import { FC } from 'react';
import { Button } from '@/components/ui/button';

export type SelectedUnitsActionBarProps = {
  numberOfSelectedUnits: number;
  onLinkUnitsClick: () => void;
};

export const SelectedUnitsActionBar: FC<SelectedUnitsActionBarProps> = ({
  numberOfSelectedUnits,
  onLinkUnitsClick,
}) => {
  const shouldShow = numberOfSelectedUnits > 0;

  return shouldShow ? (
    <div className="mb-5 flex flex-row items-center gap-4 rounded-lg bg-gray-800 p-4">
      {/* TODO: add selected checkbox, not a priority right now */}ç
      <div className="w-20 text-sm font-semibold text-white">{`${numberOfSelectedUnits} selected`}</div>
      <Button onClick={onLinkUnitsClick} variant="secondary">
        Add Unit{numberOfSelectedUnits > 1 ? 's' : ''} to Group
      </Button>
    </div>
  ) : null;
};
